import { Divider as MuiDivider, styled } from '@mui/material';

export const Divider = styled(MuiDivider)(({ theme }) => ({
  borderColor: theme.palette.border.secondary,
  width: '100%',
}));
